import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EntityForm from "./EntityForm";

export default function EntityDialog({
  open,
  title,
  initialValues,
  fields,
  loading,
  onClose,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontWeight: 1000 }}>{title}</span>
        <IconButton onClick={onClose} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        <EntityForm
          title=""
          loading={loading}
          initialValues={initialValues}
          fields={fields}
          onSubmit={onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
}